var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box, Stack, Text, IconCaution, ButtonLink, Divider } from "braid-design-system";
import { Component, useEffect } from "react";
import { analyticsEvents, analyticsAccountDropDownEvents, desktopAnlayticsEventToMobile } from "../../../EmployerFooter/AuthenticatedFooterLinks/AuthenticatedFooterLinks.mjs";
import { useEmployerHeaderContext } from "../../../EmployerFooter/EmployerFooter.mjs";
import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { AccordionToggle } from "../AccordionMenu/AccordionToggle.mjs";
import { translations } from "../../../../EmployerHeader/components/AccountInfo/.vocab/index.mjs";
import * as pageUrl from "@seek/adv-constants";
import { URL_CONTACTUS, URL_SIGNOUT } from "@seek/adv-constants";
import { testTags } from "../../EmployerHeader.mjs";
import { translations as translations$2 } from "../../../../EmployerHeader/components/.vocab/index.mjs";
import { CustomDesktopDropdownLink, CustomHeaderMobileLink } from "../Navigation/HeaderLink.mjs";
import { translations as translations$1 } from "../../../../EmployerHeader/components/Navigation/.vocab/index.mjs";
import { ScreenReaderOnly } from "../ScreenReaderHelpers/ScreenReaderOnly.mjs";
import { translations as translations$3 } from "../../../../EmployerHeader/components/AccountDropdown/.vocab/index.mjs";
import { root, menuVariants, menuContainer } from "./AccountDropdown.css.mjs";
const maxLimit = 30;
const formatAdvertiserName = (advertiserName) => {
  if (!advertiserName) {
    return void 0;
  }
  const partSlice = Math.floor(maxLimit / 2);
  const nameLength = advertiserName.length;
  const parts = advertiserName.split(" ");
  if (nameLength <= maxLimit) {
    return advertiserName;
  } else if (nameLength > maxLimit && parts.length === 1) {
    return advertiserName.slice(0, maxLimit);
  }
  const firstPart = advertiserName.slice(0, partSlice);
  const lastPart = parts[parts.length - 1].slice(-partSlice);
  return `${firstPart}...${lastPart}`;
};
const KEY_ENTER = 13;
const KEY_ESCAPE = 27;
class AccordionMenu extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", { isToggledOn: this.props.isChecked || false });
    __publicField(this, "toggleInput");
    __publicField(this, "targetElement");
    __publicField(this, "handleKeypress", (event) => {
      const keyPressed = event.keyCode;
      if (keyPressed === KEY_ESCAPE) {
        this.handleCloseDropdown();
      } else if (keyPressed === KEY_ENTER) {
        this.handleToggleDropdown(event);
      }
    });
    __publicField(this, "toggleScrollLockOnDocument", () => {
      if (this.state.isToggledOn) {
        disableBodyScroll(this.targetElement);
      } else {
        enableBodyScroll(this.targetElement);
      }
    });
    __publicField(this, "onToggleInputRef", (node) => {
      this.toggleInput = node;
    });
    __publicField(this, "handleCloseDropdown", () => {
      this.setState({ isToggledOn: false });
    });
    __publicField(this, "handleToggleDropdown", (event) => {
      this.setState((currentState) => ({
        isToggledOn: !currentState.isToggledOn
      }));
      this.props.onDropDownToggle(this.state.isToggledOn);
      this.props.onToggleButtonClick(event);
    });
    __publicField(this, "handleMenuItemClick", () => {
      this.handleCloseDropdown();
    });
  }
  componentDidMount() {
    this.toggleInput.addEventListener("keydown", this.handleKeypress, false);
    this.targetElement = document.getElementById(
      this.props.toggleScrollLockTargetId
    );
  }
  componentDidUpdate(_prevProps, prevState) {
    if (this.props.toggleScrollLockTargetId && prevState.isToggledOn !== this.state.isToggledOn) {
      this.toggleScrollLockOnDocument();
    }
  }
  componentWillUnmount() {
    this.toggleInput.removeEventListener("keydown", this.handleKeypress, false);
    if (this.props.toggleScrollLockTargetId) {
      clearAllBodyScrollLocks();
    }
  }
  render() {
    const { id, label, className, isActive } = this.props;
    const { isToggledOn } = this.state;
    return /* @__PURE__ */ jsxs(Box, { position: "relative", children: [
      /* @__PURE__ */ jsx(
        AccordionToggle,
        {
          id,
          label,
          className,
          isToggledOn,
          isActive,
          onToggleDropdown: this.handleToggleDropdown,
          onToggleInputRef: this.onToggleInputRef
        }
      ),
      this.props.render({
        onMenuItemClick: this.handleMenuItemClick
      })
    ] });
  }
}
__publicField(AccordionMenu, "defaultProps");
const AccountInfo = ({ onLinkClick }) => {
  const { t } = useTranslations(translations);
  const {
    advertiserActivationPending,
    advertiserName,
    billingId,
    name,
    switchAccountsHref
  } = useEmployerHeaderContext();
  if (!advertiserName && !billingId && !name) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
    /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
      /* @__PURE__ */ jsx(Box, { style: { wordBreak: "break-all" }, children: /* @__PURE__ */ jsx(Text, { weight: "strong", children: advertiserName }) }),
      advertiserActivationPending ? /* @__PURE__ */ jsx(Text, { icon: /* @__PURE__ */ jsx(IconCaution, {}), size: "small", tone: "caution", children: t("Pending activation") }) : /* @__PURE__ */ jsx(Text, { component: "p", children: billingId })
    ] }),
    Boolean(name) ? /* @__PURE__ */ jsx(
      Text,
      {
        component: "p",
        maxLines: 1,
        data: {
          "dd-privacy": "mask",
          "hj-masked": true,
          testid: "userName"
        },
        children: name
      }
    ) : null,
    typeof switchAccountsHref === "string" && /* @__PURE__ */ jsx(
      ButtonLink,
      {
        variant: "ghost",
        size: "small",
        href: switchAccountsHref,
        onClick: onLinkClick,
        data: {
          analytics: analyticsEvents.TRACK_SELECT_ACCOUNT
        },
        children: t("Switch account")
      }
    )
  ] });
};
const useAccountNavigationItems = (urlResolver) => {
  const { t } = useTranslations(translations$1);
  const accountMenuItems = [
    {
      id: "accountDetails",
      label: t("Account settings"),
      href: urlResolver({
        path: pageUrl.URL_ACCOUNT_DETAILS
      }),
      "data-analytics": analyticsEvents.TRACK_ACCOUNT_DETAILS,
      "data-test": testTags.ACCOUNT_DETAILS,
      analyticsEvent: analyticsAccountDropDownEvents.accountDetails,
      rel: "nofollow"
    },
    {
      id: "yourTeam",
      label: t("Your team"),
      href: urlResolver({
        path: pageUrl.URL_ACCOUNT_TEAM
      }),
      "data-analytics": analyticsEvents.TRACK_YOUR_TEAM,
      "data-test": testTags.YOUR_TEAM,
      analyticsEvent: analyticsAccountDropDownEvents.userListYourTeam,
      rel: "nofollow",
      accessPolicy: (permissionOptions) => permissionOptions.canManageUsers
    },
    {
      id: "payableInvoices",
      label: t("Payable invoices"),
      href: urlResolver({
        path: pageUrl.URL_ACCOUNT_INVOICING_PAYABLE
      }),
      "data-analytics": analyticsEvents.TRACK_PAYABLE_INVOICES,
      "data-test": testTags.PAYABLE_INVOICES,
      analyticsEvent: analyticsAccountDropDownEvents.payableInvoices,
      rel: "nofollow",
      accessPolicy: (permissionOptions) => permissionOptions.canPayInvoices
    },
    {
      id: "invoiceHistory",
      label: t("Invoice history"),
      href: urlResolver({
        path: pageUrl.URL_ACCOUNT_INVOICING_HISTORY
      }),
      "data-analytics": analyticsEvents.TRACK_INVOICE_HISTORY,
      "data-test": testTags.INVOICE_HISTORY,
      analyticsEvent: analyticsAccountDropDownEvents.invoiceHistory,
      rel: "nofollow",
      accessPolicy: (permissionOptions) => permissionOptions.canViewInvoiceHistory
    },
    {
      id: "editCompanyProfile",
      label: t("Company Profile"),
      href: urlResolver({
        path: pageUrl.URL_ACCOUNT_COMPANY_PROFILE_EDIT
      }),
      "data-analytics": analyticsEvents.TRACK_COMPANY_PROFILE,
      "data-test": testTags.COMPANY_PROFILE,
      analyticsEvent: analyticsAccountDropDownEvents.companyProfile,
      rel: "nofollow"
    },
    {
      id: "logosAndBrands",
      label: t("Logos & Brands"),
      href: urlResolver({
        path: pageUrl.URL_ACCOUNT_BRANDING
      }),
      "data-analytics": analyticsEvents.TRACK_LOGOS,
      "data-test": testTags.LOGOS,
      analyticsEvent: analyticsAccountDropDownEvents.logosAndBrands,
      rel: "nofollow",
      accessPolicy: (permissionOptions) => permissionOptions.canManageBrand
    },
    {
      id: "adPriceLookup",
      label: t("Ad price lookup"),
      href: urlResolver({
        path: pageUrl.URL_ACCOUNT_AD_PRICE_LOOKUP
      }),
      "data-analytics": analyticsEvents.TRACK_AD_PRICE_LOOKUP,
      "data-test": testTags.AD_PRICE_LOOKUP,
      analyticsEvent: analyticsAccountDropDownEvents.adPriceLookup,
      rel: "nofollow"
    }
  ];
  return {
    accountMenuItems
  };
};
const AccountNavigation = ({
  activeSubTabId,
  onMenuItemClick,
  variant,
  linkRenderer
}) => {
  const { t } = useTranslations(translations$2);
  const {
    permissionOptions,
    isSignedInToAccount,
    urlResolver,
    localisedContactInfo
  } = useEmployerHeaderContext();
  const { accountMenuItems } = useAccountNavigationItems(urlResolver);
  const contactURL = urlResolver({ path: URL_CONTACTUS });
  const signOutUrl = urlResolver({ path: URL_SIGNOUT });
  const isDesktop = variant === "desktop";
  return /* @__PURE__ */ jsx("nav", { role: "navigation", children: /* @__PURE__ */ jsxs(Stack, { space: isDesktop ? "medium" : "none", children: [
    isSignedInToAccount && accountMenuItems.filter(({ accessPolicy }) => {
      if (!accessPolicy) {
        return true;
      }
      return accessPolicy(permissionOptions);
    }).map(
      ({ label, ...headerNavItemProps }, index) => isDesktop ? /* @__PURE__ */ jsx(
        CustomDesktopDropdownLink,
        {
          "data-analytics": headerNavItemProps["data-analytics"],
          "data-test": headerNavItemProps["data-test"],
          href: headerNavItemProps.href,
          linkRenderer,
          onClick: onMenuItemClick,
          rel: headerNavItemProps.rel,
          analyticsEvent: headerNavItemProps.analyticsEvent,
          children: label
        },
        `account-nav-item-${index}`
      ) : /* @__PURE__ */ jsx(
        CustomHeaderMobileLink,
        {
          "data-analytics": headerNavItemProps["data-analytics"],
          "data-test": headerNavItemProps["data-test"],
          href: headerNavItemProps.href,
          isNested: true,
          active: headerNavItemProps.id === activeSubTabId,
          linkRenderer,
          onClick: onMenuItemClick,
          rel: headerNavItemProps.rel,
          analyticsEvent: desktopAnlayticsEventToMobile(
            headerNavItemProps.analyticsEvent
          ),
          children: label
        },
        `account-nav-item-${index}`
      )
    ),
    isDesktop ? /* @__PURE__ */ jsxs(Fragment, { children: [
      isSignedInToAccount && /* @__PURE__ */ jsx(Divider, {}),
      /* @__PURE__ */ jsx(
        CustomDesktopDropdownLink,
        {
          href: (localisedContactInfo == null ? void 0 : localisedContactInfo.contactUsLink) || contactURL,
          "data-analytics": analyticsEvents.TRACK_CONTACT_US,
          "data-test": testTags.CONTACT_US,
          onClick: onMenuItemClick,
          linkRenderer,
          analyticsEvent: analyticsAccountDropDownEvents.contactUs,
          children: t("Contact us")
        }
      ),
      /* @__PURE__ */ jsx(
        CustomDesktopDropdownLink,
        {
          href: signOutUrl,
          "data-analytics": analyticsEvents.TRACK_SIGN_OUT,
          "data-test": testTags.SIGN_OUT,
          onClick: onMenuItemClick,
          linkRenderer,
          analyticsEvent: analyticsAccountDropDownEvents.signOut,
          children: t("Sign out")
        }
      )
    ] }) : null
  ] }) });
};
const AccountDropdown = ({
  onToggleDropdown,
  linkRenderer,
  id,
  language
}) => {
  useEffect(() => {
    document.addEventListener("mousedown", handleClick, false);
    return () => {
      document.removeEventListener("mousedown", handleClick, false);
    };
  });
  const { handleInteractionTracking } = useEmployerHeaderContext();
  const { t } = useTranslations(translations$3);
  let handleClickOutside = null;
  let refNode = null;
  const handleClick = (event) => {
    const accountNav = refNode;
    if (!accountNav) {
      return;
    }
    const dropdownToggle = accountNav.previousSibling;
    if (dropdownToggle.contains(event.target) || accountNav.contains(event.target)) {
      return;
    }
    handleClickOutside();
  };
  const { hasError, dropDownLinkText, isSignedInToAccount } = useEmployerHeaderContext();
  const dropdownLabel = hasError ? t("Account") : formatAdvertiserName(dropDownLinkText);
  const handleDropDownTogggle = (isToggledOn) => {
    const analyticsEvent = isToggledOn ? analyticsAccountDropDownEvents.toggleClosed : analyticsAccountDropDownEvents.toggleOpen;
    handleInteractionTracking(analyticsEvent);
  };
  const getMenuStyles = (siteLanguage) => siteLanguage === "id" ? menuVariants.id : menuContainer;
  return /* @__PURE__ */ jsxs("div", { "aria-labelledby": "UserMenu", className: root, children: [
    /* @__PURE__ */ jsx(ScreenReaderOnly, { children: /* @__PURE__ */ jsx("span", { id: "UserMenu", children: t("User menu") }) }),
    /* @__PURE__ */ jsx(
      AccordionMenu,
      {
        id: `user-menu-toggle${id ? `-${id}` : ""}`,
        label: dropdownLabel,
        onToggleButtonClick: onToggleDropdown,
        onDropDownToggle: handleDropDownTogggle,
        render: ({ onMenuItemClick }) => {
          handleClickOutside = onMenuItemClick;
          return /* @__PURE__ */ jsx(
            Box,
            {
              id: "user-menu-content",
              data: { testid: "user-menu-content" },
              boxShadow: "medium",
              borderRadius: "large",
              background: "surface",
              ref: (node) => refNode = node,
              className: getMenuStyles(language),
              zIndex: "modal",
              children: /* @__PURE__ */ jsx(
                Box,
                {
                  borderRadius: "large",
                  boxShadow: "borderNeutralLight",
                  padding: "gutter",
                  children: /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
                    !hasError && isSignedInToAccount ? /* @__PURE__ */ jsxs(Fragment, { children: [
                      /* @__PURE__ */ jsx(
                        AccountInfo,
                        {
                          onLinkClick: () => {
                            handleInteractionTracking(
                              analyticsAccountDropDownEvents.switchAccount
                            );
                            onMenuItemClick();
                          }
                        }
                      ),
                      /* @__PURE__ */ jsx(Divider, {})
                    ] }) : null,
                    /* @__PURE__ */ jsx(
                      AccountNavigation,
                      {
                        variant: "desktop",
                        onMenuItemClick,
                        linkRenderer
                      }
                    )
                  ] })
                }
              )
            }
          );
        }
      }
    )
  ] });
};
export {
  AccordionMenu,
  AccountDropdown,
  AccountInfo,
  AccountNavigation
};
